<template>
    <div class="border-b border-dotted border-grey-55 pb-4">
        <div class="mb-2 flex gap-2 text-sm text-black">
            <div class="w-1/2">
                <p class="mb-2">{{$t('country')}}</p>
                <CountrySelect @handleChange="handleCountryChange"/>
            </div>
            <div class="w-1/2">
                <p class="mb-2">{{$t('legalTitle')}}</p>
                <LegalSelect @handleChange="handleChange"/>
            </div>
        </div>
        <p class="text-xs text-grey-90">{{$t('filterTip')}}</p>
    </div>
</template>
<script setup lang="ts">
import type { TLegalType } from '@/types';
import LegalSelect from './LegalSelect.vue'
import { useGlobalState } from '@/composables/use-global-store';
import { CountrySelect } from '@eureka/shared/country-select';
const { updateSelectLegal, updateCounty } = useGlobalState();

defineProps<{
    filterErrorStatus: boolean
}>();

function handleChange(data:TLegalType[]) {
    updateSelectLegal(data)
}

function handleCountryChange({ data, total }: { data:string[], total:number}) {
    updateCounty(data)
}

</script>
